<template>
  <div class="col-2 input-group">
    <a class="roi-help-icon" role="button" tabindex="-1">
      <span class="info-text font-main">
        <slot />
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'HelpIcon',
};
</script>

<style lang="scss" scoped>
.roi-help-icon {
  background-image: url('/getmedia/d2905b19-c6e6-4e7c-8eb1-645a551e4348/hendrickson-logo-black-H.svg');
  background-position: center;
  background-size: 70%;
  background-repeat: no-repeat;
  background-color: #dedede;
  border-radius: 4px;
  width: 40px;
  padding: 0 0 40px;
  height: 0;
  display: inline-block;
  position: relative;
  span.info-text {
    border-radius: 5px;
    display: none;
    position: absolute;
    z-index: 10;
    background: #eee;
    width: 300px;
    transform: translateY(-50%) translateX(-315px);
    top: 50%;
    font-size: 14px;
    padding: 10px;
    box-shadow: -5px 3px 5px rgba(0, 0, 0, 0.5), 5px 2px 10px rgba(0, 0, 0, 0.5);
    &::after {
      position: absolute;
      content: '';
      width: 0;
      height: 0;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;
      border-left: 20px solid #eee;
      right: -11px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &:hover,
  &:focus {
    span.info-text {
      display: block;
    }
  }
}
</style>
